export const styles = ({    
    divStyle: {
        width:'100%',
        height:'60vh',
        borderRadius: '0px 0px 100% 100%',
        backgroundColor:'#DBEAF2',
        display:'flex',
        top:'0px',
    },
    bStyle: {
        width:'100%',
        height:'40vh',
        textAlign:'center'
    },
    iconStyle:{
        width: '100%',
        height: '100%',
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'center',
    },
    divSize:{
        width: '30%',
        height: '30%'
    }
})